import Ajaxinate from "ajaxinate";

// Function to update the add-to-cart UI based on the container width
function updateAddToCartUI() {
  const containers = document.querySelectorAll(".card__content");

  containers.forEach((container) => {
    const containerWidth = container.offsetWidth;
    const addToCart = container.querySelector(".add-to-cart-wrap");
    if (addToCart) {
      addToCart.style.visibility = "visible";
      addToCart.classList.toggle("add-to-cart-compact", containerWidth < 220);
      addToCart.classList.toggle(
        "add-to-cart-icon",
        containerWidth >= 220 && containerWidth < 320
      );
      addToCart.classList.toggle(
        "add-to-cart-fullwidth",
        containerWidth >= 320
      );
    }
  });
}
// Generate reviews stars
function loadReviews() {
  if (typeof ratingSnippet === "function") {
    ratingSnippet("ruk_rating_snippet", {
      store: "ultraceuticals",
      mode: "default",
      color: "#abca37",
      linebreak: false,
      text: "Reviews",
      singularText: "Review",
      lang: "en",
      usePolaris: true,
      showEmptyStars: false,
    });
  }
}

function getPaginationContainer() {
  return document.querySelector(".pagination-wrapper");
}

function getInitialLoadedProducts() {
  return document.querySelectorAll(
    "#product-grid .product-grid__item:not(.hidden-tablet-up):not(.hidden-mobile)"
  ).length;
}

function getProductsPerBatch() {
  return parseInt(
    productGridParent.getAttribute("data-product-per-pagination"),
    10
  );
}

// Hide the repetitive collection grid banners
function hideCollectionGridBanner() {
  const hiddenTabletUpElements = document.querySelectorAll(
    "#product-grid .product-grid__item.hidden-tablet-up"
  );
  const hiddenMobileElements = document.querySelectorAll(
    "#product-grid .product-grid__item.hidden-mobile"
  );

  if (hiddenTabletUpElements.length > 1) {
    for (let i = 1; i < hiddenTabletUpElements.length; i++) {
      hiddenTabletUpElements[i].style.display = "none";
    }
  }

  if (hiddenMobileElements.length > 1) {
    for (let i = 1; i < hiddenMobileElements.length; i++) {
      hiddenMobileElements[i].style.display = "none";
    }
  }
}
function hideProgressBar() {
  document.querySelector("#progress-bar-wrap").style.visibility = "hidden";
}
function getInitialProductsToLoad() {
  return getInitialLoadedProducts() + getProductsPerBatch();
}

hideProgressBar();

function showProgressBar() {
  document.querySelector("#progress-bar-wrap").style.visibility = "visible";
}
const productGridParent = document.querySelector("#ProductGridContainer");

let totalProducts = getTotalProductQuantity();
let productsPerBatch = getProductsPerBatch();
let initialLoadedProducts = getInitialLoadedProducts();
let initialProductsToLoad = getInitialProductsToLoad();
let loadCounter = 1;

function getTotalProductQuantity() {
  const paginationContainer = getPaginationContainer();
  if (
    paginationContainer &&
    paginationContainer.hasAttribute("data-product-count")
  ) {
    return parseInt(paginationContainer.getAttribute("data-product-count"), 10);
  }
  return 0;
}

function getMoreProductsToLoad(loadCounter) {
  return loadCounter === 1
    ? initialProductsToLoad
    : initialProductsToLoad + productsPerBatch * (loadCounter - 1);
}
// Calculate the number of products to load
let productsToLoad = getMoreProductsToLoad(loadCounter);

// Determine if the third parameter should be true or false
let isComplete = getMoreProductsToLoad(loadCounter) >= totalProducts;
let isLoaded = 0;

function initializeAjaxinate() {
  if (productsToLoad >= totalProducts) {
    productsToLoad = totalProducts;
    isLoaded++;
  }
  updateProgressBar(productsToLoad, totalProducts, isLoaded);

  const endlessScroll = new Ajaxinate({
    container: "#product-grid",
    pagination: ".pagination-wrapper",
    method: "scroll",
    offset: 100,
    loadingText: "",
    callback: () => {
      updateAddToCartUI();
      loadReviews();
      loadCounter++;
      productsToLoad = getMoreProductsToLoad(loadCounter);
      isComplete = productsToLoad >= totalProducts;
      if (isComplete) {
        productsToLoad = totalProducts;
        isLoaded++;
      }
      hideCollectionGridBanner();
      updateProgressBar(productsToLoad, totalProducts, isLoaded);
    },
  });
}
function reInitializeAjaxinate() {
  loadCounter = 1;
  isLoaded = 0;

  productsToLoad = getMoreProductsToLoad(loadCounter);
  totalProducts = getTotalProductQuantity();

  if (productsToLoad >= totalProducts) {
    productsToLoad = totalProducts;
    isLoaded++;
  }
  updateProgressBar(productsToLoad, totalProducts, isLoaded);

  const endlessScroll = new Ajaxinate({
    container: "#product-grid",
    pagination: ".pagination-wrapper",
    method: "scroll",
    offset: 100,
    loadingText: "",
    callback: () => {
      updateAddToCartUI();
      loadReviews();
      loadCounter++;
      productsToLoad = getMoreProductsToLoad(loadCounter);
      isComplete = productsToLoad >= totalProducts;

      if (isComplete) {
        productsToLoad = totalProducts;
        isLoaded++;
      }
      hideCollectionGridBanner();
      updateProgressBar(productsToLoad, totalProducts, isLoaded);
    },
  });
}

// Initial Ajaxinate initialization on page load
if (getPaginationContainer()) {
  initializeAjaxinate();
}

// Function to update the progress bar based on loaded products
function updateProgressBar(productsToLoad, totalProducts, isLoaded) {
  showProgressBar();
  let progressBarInner = document.getElementById("progress-bar-inner");
  let progressBarText = document.getElementById("progress-bar-text");
  let progressPercentage = (productsToLoad / totalProducts) * 100;
  progressBarInner.style.width = progressPercentage + "%";
  if (isLoaded === 2) {
    progressBarText.innerText = `Loaded ${totalProducts} of ${totalProducts} products`;
  } else {
    progressBarText.innerText = `Loading ${productsToLoad} of ${totalProducts} products`;
  }
}

// Initialize the filter functionality
function initializeFilterToggle() {
  const filterIcon = document.getElementById("filter-icon");
  const filterSection = document.querySelector("#main-collection-filters");
  const desktopFilterForm = document.querySelector(".facets--desktop");
  const mobileFilterForm = document.querySelector(".facets--mobile");
  const facetOptionsDesktop = document.querySelector(
    "#FacetsWrapperDesktop .facets__options"
  );
  const facetOptionsMobile = document.querySelector(
    "#FacetsWrapperMobile .facets__options"
  );
  const filterCloseButton = document.querySelector(".facets-close");

  if (
    !filterIcon ||
    !filterSection ||
    !desktopFilterForm ||
    !mobileFilterForm ||
    !facetOptionsDesktop ||
    !facetOptionsMobile ||
    !filterCloseButton
  ) {
    console.error("One or more necessary elements not found.");
    return;
  }

  filterSection.style.visibility = "hidden";
  filterCloseButton.style.visibility = "hidden";

  function toggleFilterVisibility() {
    const isHidden = filterSection.style.visibility === "hidden";
    filterSection.style.visibility = isHidden ? "visible" : "hidden";
    filterSection.style.left = isHidden ? "0" : "-100%";
    desktopFilterForm.classList.toggle("facets--open", isHidden);
    mobileFilterForm.classList.toggle("facets--open", isHidden);
    facetOptionsDesktop.style.display = isHidden ? "block" : "none";
    facetOptionsMobile.style.display = isHidden ? "block" : "none";
    filterCloseButton.style.visibility = isHidden ? "visible" : "hidden";
  }

  function hideFilter() {
    filterSection.style.left = "0";
    filterSection.style.visibility = "hidden";
    desktopFilterForm.classList.remove("facets--open");
    mobileFilterForm.classList.remove("facets--open");
    facetOptionsDesktop.style.display = "none";
    facetOptionsMobile.style.display = "none";
    filterCloseButton.style.visibility = "hidden";
  }

  filterIcon.addEventListener("click", toggleFilterVisibility);
  filterCloseButton.addEventListener("click", hideFilter);
}

initializeFilterToggle();

const productGridFlitered = document.querySelector("#ProductGridContainer");

const mutationCallback = function (mutationsList, observer) {
  for (let mutation of mutationsList) {
    if (mutation.type === "childList") {
      const paginationContainer = getPaginationContainer();
      if (paginationContainer) {
        reInitializeAjaxinate();
      } else {
        hideProgressBar();
      }
    }
  }
};

const productGridFilteredObserver = new MutationObserver(mutationCallback);
productGridFilteredObserver.observe(productGridFlitered, {
  childList: true,
  subtree: false,
});
